module.exports = __webpack_public_path__ + "img/filter-white.b9dcb174.svg";